export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-6">
            关于大师兄影视
          </h2>

          <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            <p>
              大师兄影视是一个专注于高品质影视内容聚合与分发的在线平台。我们致力于为华语观众提供最新上映电影、
              热播电视剧和热门综艺节目的高清免费在线观看服务，以更新快、片源全、播放流畅为核心优势。
            </p>
            <p>
              平台内容覆盖院线大片、平台独播剧、经典怀旧、动漫、纪录片、综艺娱乐等全品类，
              片库总量超过12,000部，且每天都在持续增长。我们的内容团队24小时不间断监控全球各大影视平台和院线动态，
              确保在第一时间为观众奉上最新资源。
            </p>
            <p>
              大师兄影视坚持「好内容不该有门槛」的理念，全站无需注册登录即可免费观看，
              致力于打造纯净、流畅、高品质的观影环境，让每一位热爱影视的观众都能在这里找到属于自己的光影世界。
            </p>
          </div>

          {/* Stats row */}
          <div className="grid grid-cols-3 gap-6 md:gap-10 mt-10 md:mt-12 pt-8 border-t border-background-200/60">
            <div>
              <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">3年</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1 whitespace-nowrap">稳定运营</div>
            </div>
            <div>
              <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">12000+</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1 whitespace-nowrap">影视资源</div>
            </div>
            <div>
              <div className="text-2xl md:text-3xl font-bold text-secondary-500 font-heading">500万+</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1 whitespace-nowrap">月活用户</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}